/* eslint-disable max-len */
export const messages = {
  profile: {
    sales: {
      heading: {
        agrarian: 'Мои заявки на продажу',
        buyer: 'Заявки',
      },
      successOrderNotification: {
        multiple: {
          title: 'Мультизаявка создается.',
          description: 'После создания она отобразится в личном кабинете в разделе «Заявки на урожай».',
        },
        solo: {
          title: 'Заявка оформлена.',
          description: 'Уведомление об ответе мы направим вам на E-mail и в sms.',
        },
      },
      filter: {
        culture: 'Культура',
        regions: 'Регион',
        statuses: 'Статус заявки',
        buyer: 'Покупатель',
        agrarian: 'Поиск по продавцу урожая',
        searchByBuyerName: 'Поиск по покупателю урожая',
        requestId: 'Поиск по номеру заявки',
        showAll: {
          title: 'Все фильтры',
          cultures: 'Все культуры',
          regions: 'Все регионы',
        },
        hide: 'Свернуть',
        empty: {
          title: 'Нет заявок по этим фильтрам',
          description: 'Попробуйте изменить критерии поиска',
          button: 'Сбросить фильтры',
        },
      },
    },
  },
  agrarianSales: {
    sorterButtons: {
      current: 'Активные',
      completed: 'Завершенные',
      canceled: 'Отмененные',
    },
  },
}
